import { addDisplayName, flowMax } from 'ad-hok'
import { addLayoutEffectOnMount, branchIfFalsy } from 'ad-hok-utils'
import { FC } from 'react'
import { addApi } from 'shared/src/api'
import { addOptionalPathParam } from 'shared/src/utils/addNavigate'

import { addSiteVisitAnalyticsEventFiring } from 'utils/analytics'
import { addLaunchContext } from 'utils/launchContext'

export const Page: FC = flowMax(
  addDisplayName('Page'),
  addOptionalPathParam('username'),
  addLaunchContext,
  addApi,
  addLayoutEffectOnMount(
    ({ username, hasMountedInitialPage, setLaunchPayload, api }) =>
      () => {
        if (hasMountedInitialPage) {
          return
        }

        if (!username) {
          setLaunchPayload({})
          return
        }

        api.users
          .details(username)
          .then((user) => {
            setLaunchPayload({ user })
          })
          .catch((error) => {
            console.error('Error fetching initial user', error)
            setLaunchPayload({})
          })
      }
  ),
  branchIfFalsy('hasMountedInitialPage'),
  addSiteVisitAnalyticsEventFiring,
  ({ children }) => <>{children}</>
)
